<template>
  <!-- S06 · Field: una sola tarjeta con (1) fechas de instalacion (planificacion, solo lectura) +
       observaciones y (2) catalogos de personal tecnico y empresas (edicion por tabla). -->
  <div class="s06">
    <summary-card :title="$t('prm_summary_s06_title')" :mode="mode" :mark="true" chip="field">
      <template #extra><span class="s06-hint">{{ $t('prm_summary_s06_dates_hint') }}</span></template>
      <!-- Seccion 1: fechas (izquierda, con border-r) + observaciones (derecha). Grid a ras, sin gap ni padding. -->
      <div class="s06-sec1">
        <div class="s06-dates">
          <div class="kv"><span class="k">{{ $t('prm_summary_s06_install_start') }}</span><span class="v">{{ fmtDate(installStart) || '-' }}</span></div>
          <div class="kv"><span class="k">{{ $t('prm_summary_s06_install_end') }}</span><span class="v">{{ fmtDate(installEnd) || '-' }}</span></div>
        </div>
        <div class="s06-obs">
          <div class="kv">
            <span class="k">{{ $t('prm_summary_s06_observations') }}</span>
            <span class="v"><textarea class="obs-ta" :value="s06.observations || ''" :placeholder="$t('prm_summary_s06_obs_ph')"
                    @change="$emit('save-field', { path: 's06.observations', value: $event.target.value })"></textarea></span>
          </div>
        </div>
      </div>

      <!-- Seccion 2: personal tecnico (izquierda) + empresas (derecha) -->
      <div class="s06-sec2">
        <!-- Personal tecnico FLD -->
        <section class="fl-sec">
          <div class="fl-sec-head">
            <span class="fl-sec-title">{{ $t('prm_summary_s06_personnel') }}</span>
            <button class="fl-edit" @click="editTech = !editTech">
              <b-icon pack="fas" :icon="editTech ? 'check' : 'pen'" size="is-small"></b-icon><span>{{ editTech ? $t('prm_summary_s03_save') : $t('prm_summary_s03_edit') }}</span>
            </button>
          </div>
          <div class="fl-scroll">
            <table class="fl-table">
              <thead>
                <tr>
                  <th class="num">#</th>
                  <th>{{ $t('prm_summary_s06_col_name') }}</th>
                  <th>{{ $t('prm_summary_s06_col_specialty') }}</th>
                  <th v-if="editTech" class="act"></th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(t, i) in localTech" :key="t._k">
                  <td class="num">{{ i }}</td>
                  <td>
                    <template v-if="editTech">
                      <input class="fl-in" type="text" :value="t.name" :placeholder="$t('prm_summary_s06_col_name')" @change="onTech(i, 'name', $event.target.value)">
                      <input class="fl-in email" type="text" :value="t.email" :placeholder="$t('prm_summary_s06_col_email')" @change="onTech(i, 'email', $event.target.value)">
                    </template>
                    <template v-else>
                      <div class="fl-name">{{ t.name || '-' }}</div>
                      <div v-if="t.email" class="fl-email">{{ t.email }}</div>
                    </template>
                  </td>
                  <td>
                    <input v-if="editTech" class="fl-in" type="text" :value="t.specialty" :placeholder="$t('prm_summary_s06_col_specialty')" @change="onTech(i, 'specialty', $event.target.value)">
                    <span v-else class="fl-val">{{ t.specialty || '-' }}</span>
                  </td>
                  <td v-if="editTech" class="act"><button class="fl-del" v-tip="$t('prm_summary_remove_row')" @click="removeTech(i)"><b-icon pack="fas" icon="xmark" size="is-small"></b-icon></button></td>
                </tr>
                <tr v-if="!localTech.length"><td :colspan="editTech ? 4 : 3" class="empty">{{ $t('prm_summary_empty') }}</td></tr>
              </tbody>
            </table>
          </div>
          <div v-if="editTech" class="fl-foot"><button class="fl-add" @click="addTech"><b-icon pack="fas" icon="plus" size="is-small"></b-icon><span>{{ $t('prm_summary_s06_add_personnel') }}</span></button></div>
        </section>

        <!-- Empresas -->
        <section class="fl-sec">
          <div class="fl-sec-head">
            <span class="fl-sec-title">{{ $t('prm_summary_s06_companies') }}</span>
            <button class="fl-edit" @click="editComp = !editComp">
              <b-icon pack="fas" :icon="editComp ? 'check' : 'pen'" size="is-small"></b-icon><span>{{ editComp ? $t('prm_summary_s03_save') : $t('prm_summary_s03_edit') }}</span>
            </button>
          </div>
          <div class="fl-scroll">
            <table class="fl-table">
              <thead>
                <tr><th class="num">#</th><th>{{ $t('prm_summary_s06_col_company') }}</th><th v-if="editComp" class="act"></th></tr>
              </thead>
              <tbody>
                <tr v-for="(c, i) in localComp" :key="c._k">
                  <td class="num">{{ i }}</td>
                  <td>
                    <input v-if="editComp" class="fl-in" type="text" :value="c.name" :placeholder="$t('prm_summary_s06_company_ph')" @change="onComp(i, 'name', $event.target.value)">
                    <span v-else class="fl-val">{{ c.name || '-' }}</span>
                  </td>
                  <td v-if="editComp" class="act"><button class="fl-del" v-tip="$t('prm_summary_remove_row')" @click="removeComp(i)"><b-icon pack="fas" icon="xmark" size="is-small"></b-icon></button></td>
                </tr>
                <tr v-if="!localComp.length"><td :colspan="editComp ? 3 : 2" class="empty">{{ $t('prm_summary_empty') }}</td></tr>
              </tbody>
            </table>
          </div>
          <div v-if="editComp" class="fl-foot"><button class="fl-add" @click="addComp"><b-icon pack="fas" icon="plus" size="is-small"></b-icon><span>{{ $t('prm_summary_s06_add_company') }}</span></button></div>
        </section>
      </div>
    </summary-card>
  </div>
</template>

<script>
  import SummaryCard from './summary-card.vue'
  import { fmtDate } from '../shared/format'
  import { tip } from '../shared/tip'

  let k = 0

  export default {
    name: 'PrmSummaryS06',

    components: { SummaryCard },

    directives: { tip },

    props: {
      doc: { type: Object, required: true },
      sources: { type: Object, default: () => ({}) },
      mode: { type: Boolean, default: false },
      resetKey: { type: Number, default: 0 },
    },

    data: () => ({ localTech: [], localComp: [], editTech: false, editComp: false }),

    computed: {
      s06 () { return this.doc.s06 || {} },
      // Fechas de instalacion: planificacion vigente del proyecto (solo lectura).
      installStart () { return (this.sources.dates || {}).currentStart },
      installEnd () { return (this.sources.dates || {}).currentEnd },
    },

    watch: {
      resetKey: { immediate: true, handler () { this.init() } },
    },

    methods: {
      fmtDate,
      init () {
        this.localTech = (this.s06.technicians || []).map((t) => ({ ...t, _k: ++k }))
        this.localComp = (this.s06.companies || []).map((c) => ({ ...c, _k: ++k }))
      },
      clean (rows) { return rows.map((r) => { const o = { ...r }; delete o._k; return o }) },

      onTech (i, key, value) { this.localTech[i][key] = value; this.emitTech() },
      addTech () { this.localTech.push({ name: '', email: '', specialty: '', _k: ++k }); this.emitTech() },
      removeTech (i) { this.localTech.splice(i, 1); this.emitTech() },
      emitTech () { this.$emit('save-list', { path: 's06.technicians', items: this.clean(this.localTech) }) },

      onComp (i, key, value) { this.localComp[i][key] = value; this.emitComp() },
      addComp () { this.localComp.push({ name: '', _k: ++k }); this.emitComp() },
      removeComp (i) { this.localComp.splice(i, 1); this.emitComp() },
      emitComp () { this.$emit('save-list', { path: 's06.companies', items: this.clean(this.localComp) }) },
    },
  }
</script>

<style lang="scss" scoped>
  .s06 { display: flex; flex-direction: column; }

  // Hint a la derecha del header (texto normal, no en mayusculas ni negrita).
  .s06-hint { font-size: 9px; font-weight: 400; text-transform: none; letter-spacing: 0; color: #7a8798; }

  // Seccion 1: fechas | observaciones (2 columnas, se apilan en estrecho).
  // Seccion 1: fechas | observaciones. Grid a ras (sin gap ni padding); col1 divide con border-r.
  .s06-sec1 { display: grid; grid-template-columns: 1fr 1fr; }
  .s06-dates { border-right: 1px solid #eef0f3; }
  .kv { display: flex; border-bottom: 1px solid #eef0f3; }
  .kv .k { width: 220px; flex-shrink: 0; padding: 6px 8px; background: #f6f8fa; font-size: 10px; font-weight: 600; text-transform: uppercase; letter-spacing: .02em; color: #5a7896; }
  .kv .v { flex: 1 1 auto; min-width: 0; padding: 6px 8px; font-size: 11px; color: #2c3a4d; }
  .obs-ta {
    width: 100%; min-height: 60px; resize: vertical; box-sizing: border-box; font-family: inherit;
    font-size: 11px; line-height: 1.6; color: #1f2837; border: 1px solid #cbd5e1; border-radius: 4px; padding: 6px 8px; outline: none;
  }
  .obs-ta:focus { border-color: #3a6bc8; box-shadow: 0 0 0 2px rgba(58, 107, 200, .12); }
  .obs-ta::placeholder { color: #9aa4b2; }

  // Seccion 2: personal | empresas (2 columnas con separacion), linea superior.
  .s06-sec2 { display: grid; grid-template-columns: 1fr 1fr; gap: 16px; padding: 12px; border-top: 1px solid #eef0f3; align-items: start; }
  @media (max-width: 768px) { .s06-sec1, .s06-sec2 { grid-template-columns: 1fr; } .s06-dates { border-right: 0; } }

  // Cabecera plana de cada catalogo: titulo (izquierda) + boton Editar/Guardar (derecha).
  .fl-sec { min-width: 0; }
  .fl-sec-head { display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px; }
  .fl-sec-title { font-size: 10px; font-weight: 700; text-transform: uppercase; letter-spacing: .02em; color: #47566b; }
  .fl-edit { display: inline-flex; align-items: center; gap: 5px; border: 1px solid #d3dae4; background: #fff; color: #425b76; font-size: 9px; font-weight: 600; padding: 4px 8px; border-radius: 4px; cursor: pointer; white-space: nowrap; }
  .fl-edit:hover { background: #f4f8fc; }

  .fl-scroll { overflow-x: auto; border: 1px solid #e6ebf1; border-radius: 6px; }
  .fl-table { width: 100%; border-collapse: collapse; }
  .fl-table th { background: #3d6b9a; color: #fff; font-size: 10px; font-weight: 700; padding: 6px 8px; text-align: left; white-space: nowrap; }
  .fl-table th.num { width: 34px; text-align: center; }
  .fl-table th.act { width: 40px; }
  .fl-table td { border-bottom: 1px solid #eef0f3; padding: 6px 8px; font-size: 10px; color: #1f2837; vertical-align: middle; }
  .fl-table tbody tr:last-child td { border-bottom: 0; }
  .fl-table td.num { text-align: center; color: #6b7787; }
  .fl-table td.empty { text-align: center; color: #9aa4b2; padding: 12px; }

  .fl-name { font-size: 10px; font-weight: 600; color: #1f2837; }
  .fl-email { font-size: 9px; color: #4a7db5; margin-top: 1px; }
  .fl-val { font-size: 10px; color: #1f2837; }

  .fl-in {
    width: 100%; font-size: 10px; color: #1f2837; border: 1px solid #d8dde4; border-radius: 4px;
    padding: 4px 8px; height: 24px; box-sizing: border-box; outline: none; background: #fff;
  }
  .fl-in:focus { border-color: #3a6bc8; box-shadow: 0 0 0 2px rgba(58, 107, 200, .12); }
  .fl-in.email { margin-top: 3px; }
  .fl-in::placeholder { color: #9aa4b2; }

  .fl-del {
    display: inline-flex; align-items: center; justify-content: center; width: 28px; height: 26px;
    border: 1px solid #d8dde4; border-radius: 4px; background: transparent; color: #dc2626; cursor: pointer;
  }
  .fl-del:hover { background: #fdecea; border-color: #f0c2c2; }

  .fl-foot { padding: 8px 0 0; }
  .fl-add { display: inline-flex; align-items: center; gap: 5px; border: 1px solid #33475f; background: #33475f; color: #fff; font-size: 9px; font-weight: 600; padding: 4px 10px; border-radius: 4px; cursor: pointer; }
  .fl-add:hover { background: #2a3b50; }
</style>
